import { LoginContainer } from "app/styles";
import { TrainLoaderIcon } from "shared/icons/TrainLoaderIcon";

export const TrainLoader = () => (
  <LoginContainer>
    <TrainLoaderIcon />
  </LoginContainer>
);
